export default __webpack_public_path__ + "static/pict1Placeholder-0a7ba097b9aad7d485fbf657b02f9eb2.png";